// SubMenu.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './SubMenu.css';
import * as FaIcons from 'react-icons/fa';

const SubMenu = ({ item }) => {
  const [subnav, setSubnav] = useState(false);

  const showSubnav = () => setSubnav(!subnav);

  return (
    <>
      <Link to={item.path} className="sidebar-link" onClick={item.subNav && showSubnav}>
        <div>
          {item.icon}
          <span className="sidebar-label">{item.title}</span>
        </div>
        <div>
          {item.subNav && subnav ? <FaIcons.FaAngleDown /> : item.subNav ? <FaIcons.FaAngleRight /> : null}
        </div>
      </Link>
      {item.subNav && subnav && (
        <div className={`dropdown-container ${subnav ? 'open' : ''}`}>
          {item.subNav.map((subItem, subIndex) => (
            <Link to={subItem.path} className="dropdown-link" key={subIndex}>
              <div>
                {subItem.icon}
                <span className="sidebar-label">{subItem.title}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </>
  );
};

export default SubMenu;
